import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
           
    }

    trigger(e) {

        if(e.way === 'enter') {
            html.setAttribute('data-ui',e.obj.el.getAttribute('data-value'));
        } else {
            html.setAttribute('data-ui','');
        }
    }
}
